import classNames from "classnames";
import React, { CSSProperties, ReactNode } from "react";
import { Dropdown } from "react-bootstrap";
import { Button } from "../button";
import { helper } from "../utils";
import { useAutoFocus } from "../utils/use-auto-focus";

type TextFieldProps = {
    variant?: "outline" | "fill" | "standard";
    id?: string;
    type?: "textarea" | "select" | "text" | "number" | "email" | "password" | "search" | "time" | "url";
    autoComplete?: "on" | "off";
    spellCheck?: boolean;
    autoFocus?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    inputClassName?: string;
    inputStyle?: CSSProperties | undefined;
    inputRef?: any;

    error?: string;
    showErrorLabel?: boolean;

    buttonIcon?: ReactNode;
    buttonOnClick?: (e: any) => void;

    className?: string;
    height?: any;
    width?: any;
    maxWidth?: any;
    style?: CSSProperties | undefined;

    onChange?: (e: any) => void;
    children?: ReactNode;
    [x: string]: any;
};

export const TextField = ({
    variant = "outline",
    id,
    type = "text",
    autoComplete = "off",
    spellCheck = false,
    autoFocus,
    readOnly,
    disabled,
    inputClassName,
    inputStyle,
    inputRef,

    error,
    showErrorLabel,

    buttonIcon,
    buttonOnClick,

    items,

    className,
    height,
    width,
    maxWidth,
    style,

    onChange,
    children,
    ...props
}: TextFieldProps) => {
    if (autoFocus) inputRef = useAutoFocus(200, inputRef);
    if (!type) type = "text";
    if (children && (type === "select" || type === "textarea")) type = "text";
    const is_select = type === "select";
    const is_textarea = type === "textarea";
    const cnInput = classNames(inputClassName, {
        "form-control": !is_select,
        "form-select": is_select,

        "bd-input-fill": variant === "fill",
        "bd-input-standard": variant === "standard",

        "has-1-btn": buttonIcon,
        "bd-input-readonly": readOnly,
        "bd-input-disabled": disabled,
        "bd-border-error": error,
    });

    if (is_select) {
        if (readOnly) disabled = true;
        readOnly = undefined;
        type = undefined;
    }

    if (is_textarea) {
        type = undefined;
    }

    var newProps = {
        id,
        type,
        ref: inputRef,
        className: cnInput,
        autoComplete,
        spellCheck,
        readOnly,
        disabled,

        style: { ...inputStyle, height },
        onChange,

        ...props,
        title: error,
    };

    const getValue = (item) =>
        !item || typeof item !== "object" ? item : "id" in item ? item["id"] : "code" in item ? item["code"] : item;
    const getText = (item) => (!item || typeof item !== "object" ? item : "title" in item ? item["title"] : item);

    let inp = null;

    if (is_textarea) inp = <textarea {...newProps}></textarea>;
    else if (is_select)
        inp = (
            <select {...newProps}>
                {items.map((x: any) => (
                    <option key={getValue(x)} value={getValue(x)}>
                        {getText(x)}
                    </option>
                ))}
            </select>
        );
    else inp = <input {...newProps} />;

    if (children) {
        return (
            <Dropdown>
                <div className={classNames("bd-input", className)} style={{ ...style, width, maxWidth }}>
                    {inp}
                    <Dropdown.Toggle className="btn1 icon-btn btn btn-text bg-transparent text-primary" type="button"></Dropdown.Toggle>
                    {showErrorLabel && error && <div className="bd-error">{error}</div>}
                </div>
                <Dropdown.Menu align={helper.isRTL() ? "start" : "end"} className="w-100 overflow-hidden">
                    {children}
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    return (
        <div className={classNames("bd-input", className)} style={{ ...style, width, maxWidth }}>
            {inp}
            {buttonIcon && (
                <Button type="button" className="btn1 size-md icon-btn" onClick={buttonOnClick}>
                    {buttonIcon}
                </Button>
            )}
            {showErrorLabel && error && <div className="bd-error small">{error}</div>}
        </div>
    );
};
